import { createContext } from "react";
import ReactConfig from "./ReactConfig";
var contextValue = {
    config: ReactConfig
};
var ReactConfigContext = /*#__PURE__*/ createContext(contextValue);
export default ReactConfigContext;

//# sourceMappingURL=ReactConfigContext.js.map